import { DefaultProductOptions } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

// This tag if for when a user manually adds a quick address when adding a recipient address
export const getAddManualAddressRecipientTag = (options: DefaultProductOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const addManualAddressRecipientEvent = [
    {
      eventInfo: {
        eventName: 'recipient address',
        eventAction: 'manual add address',
      },
    },
    {
      eventInfo: {
        eventName: 'Quick Address',
        eventAction: 'Save Address',
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    addManualAddressRecipientEvent,
    options.projectID,
  );

  return {
    modal,
    product,
    user,
  };
};
